(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  function initSearchPlaceholder(input) {
    if (input.dataset.placeholderInit) return;
    input.dataset.placeholderInit = 'true';

    const raw = input.dataset.searchSuggestions;
    if (!raw) return;

    const suggestions = raw.split('|').filter(Boolean);
    if (suggestions.length === 0) return;

    const label = document.querySelector('label[for="' + input.id + '"]');

    let index = 0;
    let charIndex = 0;
    let typeTimer = null;
    let holdTimer = null;

    function applyText(text) {
      input.setAttribute('placeholder', text);
      if (label) {
        label.textContent = text;
      }
    }

    function typeNext() {
      const fullText = 'Search "' + suggestions[index] + '"';
      charIndex++;
      applyText(fullText.slice(0, charIndex));

      if (charIndex < fullText.length) {
        typeTimer = setTimeout(typeNext, 60);
      } else {
        holdTimer = setTimeout(function () {
          index = (index + 1) % suggestions.length;
          charIndex = 0;
          typeNext();
        }, 1800);
      }
    }

    function startTyping() {
      clearTimeout(typeTimer);
      clearTimeout(holdTimer);
      charIndex = 0;
      typeNext();
    }

    function isFloated() {
      return document.activeElement === input || input.value.length > 0;
    }

    function updateFloatState() {
      if (!label) return;
      if (isFloated()) {
        label.classList.add('field__label--floated');
      } else {
        label.classList.remove('field__label--floated');
      }
    }

    startTyping();

    input.addEventListener('focus', updateFloatState);
    input.addEventListener('blur', updateFloatState);
    input.addEventListener('input', updateFloatState);
  }

  function setup() {
    document.querySelectorAll('.search__input[data-search-suggestions]').forEach(initSearchPlaceholder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-values"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.values-card');
  if (!('IntersectionObserver' in window) || cards.length === 0) {
    cards.forEach(function (card) { card.classList.add('is-visible'); });
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  cards.forEach(function (card) { observer.observe(card); });
});

  } catch(e) { console.error(e); }
})();
})();
